import { TOptions } from 'i18next';
import React, { useMemo } from 'react';

import { AdminTableEnum } from 'src/models/Administration/common';
import { AdministrationMenu } from 'src/pages/Administration/Menu';
import { usePageTitle } from 'src/utils/hooks/usePageTitle';
import { SafeAnyType } from 'src/utils/safeAny';
import { useNsTHelper } from 'src/utils/i18n';

type Props = {
  children: React.ReactNode;
  type: AdminTableEnum;
  localeOptions?: TOptions<Record<string, SafeAnyType>>;
};

export const AdministrationInnerLayout: React.FC<Props> = ({ children, type, localeOptions }: Props) => {
  const tHelper = useNsTHelper('administration.index');
  const tHelperType = useNsTHelper(`administration.${type}`);

  const partnerLayout = useMemo(
    () =>
      [
        AdminTableEnum.ADMIN_PARTNER_CAMPAIGNS,
        AdminTableEnum.ADMIN_PARTNER_ORGANIZATIONS,
        AdminTableEnum.ADMIN_PARTNER_ORGANIZATIONS_ADMINISTRATORS,
        AdminTableEnum.ADMIN_PARTNER_TRANSACTIONS,
        AdminTableEnum.ADMIN_PARTNER_TRANSACTIONS_CHARGEBACKS,
        AdminTableEnum.ADMIN_PARTNER_USERS,
        AdminTableEnum.ADMIN_PARTNER_ADMINISTRATORS,
        AdminTableEnum.ADMIN_PARTNER_API,
        AdminTableEnum.ADMIN_PARTNER_FUNDING,
        AdminTableEnum.ADMIN_PARTNER_WEBHOOKS,
        AdminTableEnum.ADMIN_PARTNER_EXPERIENCE_TEMPLATES,
        AdminTableEnum.ADMIN_PARTNER_AUDIT,
      ].includes(type),
    [type]
  );

  usePageTitle([tHelper('commonPageTitle'), tHelperType('pageTitle')], true);

  return (
    <div
      id="administration" // CustomBrandingTemplate.less
      className={`container-fluid ${partnerLayout ? 'partner-administration' : 'administration'}`}
    >
      <div className="row">
        <div className="col-xs-12 page-header clearfix">
          <h1 className="page-header-administration HeaderTextColor">{tHelper('title')}</h1>
          <h5 className="page-header-title">
            <span className="separator">|</span>
            <span className="page-header-title-text PageTitleTextWithoutBackgroundColor">
              {tHelperType(`title`, localeOptions)}
            </span>
          </h5>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-2 col-md-2 col-lg-1">
          <AdministrationMenu partner={partnerLayout} />
        </div>
        <div className="col-sm-10 col-md-10 col-lg-11">{children}</div>
      </div>
    </div>
  );
};
